// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__3XqU_","icon":"style_icon__1GrJR","title":"style_title__1BfKg"};